<template>
  <!-- Add Leave Modal -->
  <div id="add_leave" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Leave</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
			ref="addleaveclose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Employee <span class="text-danger">*</span></label
              >
			  <Field
                    name="employee_id"
                    as="select"
                    class="form-control"
					v-model="form.employee_id"
					:class="{ 'is-invalid': errors.employee_id }"
                  >
				  <option value="">Select Employee</option>
				  <option v-for="employee in employeelist" :key="employee.id" :value="employee.id">{{ employee.first_name }} {{employee.last_name}}</option>
				  <div class="invalid-feedback">{{ errors.employee_id }}</div>
                  <div class="employee_idshow text-danger" id="employee_id"></div>
			  </Field>
			</div>
			<!--
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Leave Type <span class="text-danger">*</span></label
              >
			  <Field
                    name="leave_type_id"
                    as="select"
                    class="form-control"
					v-model="form.leave_type_id"
					:class="{ 'is-invalid': errors.leave_type_id }"
                  >
				  <option value="">Select Leave Type</option>
				  <option v-for="leavetype in leavetypelist" :key="leavetype.id" :value="leavetype.id">{{ leavetype.type }}</option>
				  <div class="invalid-feedback">{{ errors.leave_type_id }}</div>
                  <div class="leave_type_idshow text-danger" id="leave_type_id"></div>
			  </Field>
			</div> -->
			<div class="input-block mb-3">
			  <label class="col-form-label"
                >Leave Type <span class="text-danger">*</span></label
              >
			  <Field
                    name="leave_type_id"
                    as="select"
                    class="form-control"
					v-model="form.leave_type_id"
					:class="{ 'is-invalid': errors.leave_type_id }"
				    @change="onLeaveTypeChange"
                  >
				  <option value="">Select Leave Type</option>
				  <option v-for="leavetype in newleavetypelist" :key="leavetype.id" :value="leavetype.id">{{ leavetype.name }}</option>
				  <div class="invalid-feedback">{{ errors.leave_type_id }}</div>
                  <div class="leave_type_idshow text-danger" id="leave_type_id"></div>
			  </Field>
			</div>
            <div class="input-block mb-3">
              <label class="col-form-label"
                >From <span class="text-danger">*</span></label
              >
              <div class="cal-icon">
                <datepicker
                  v-model="createdfrom"
                  class="form-control datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
				/>
              </div>
            </div>
            <div class="input-block mb-3">
              <label class="col-form-label">To <span class="text-danger">*</span></label>
              <div class="cal-icon">
                <datepicker
                  v-model="createdto"
                  class="form-control datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
				/>
              </div>
            </div>
			
			<div class="row" v-if="form.leavedetails">
			  <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6" v-for="(item, index) in form.leavedetails" :key="item">
				  <div class="input-block mb-3" >
					<label class="col-form-label">{{item.leave_details_date}} <span class="text-danger"></span></label>
					<div class="form-check">
						<input type="radio" value="FULLDAY"  v-model="form.leavedetails[index]['leave_details_type']" /> Full Day 
					</div>	
					<div class="form-check">
					<input type="radio" value="HALFDAY"  v-model="form.leavedetails[index]['leave_details_type']"  /> Half Day
					</div>
				   </div>
			   </div>
			</div>
			
			
			<!---
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Number of days <span class="text-danger">*</span></label
              >
              <input class="form-control" readonly type="text" />
            </div> -->
			<!--
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Remaining Leaves <span class="text-danger">*</span></label
              >
              <input class="form-control" readonly value="12" type="text" />
            </div> -->
            
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Leave Reason <span class="text-danger">*</span></label
              >
              <Field
                    name="reason"
                    as="textarea"
                    value=""
                    class="form-control"
					v-model="form.reason"
					rows="4"
					:class="{ 'is-invalid': errors.reason }"
                  />
                  <div class="invalid-feedback">{{ errors.reason }}</div>
                  <div class="nameshow text-danger" id="reason"></div>
            </div>
			
			<!-- 📎 File Upload -->
		  <div class="input-block mb-3">
			<label class="col-form-label">Attachment (optional)</label>
			<input
			  type="file"
			  name="attachment"
			  class="form-control"
			  accept=".jpg,.jpeg,.png,.pdf"
			  @change="onFileChange"
			  ref="addFileInput"
			/>
			<small class="text-muted">Allowed: JPG, PNG, PDF (max 2MB)</small>

			<div v-if="filePreview" class="mt-2">
			  <template v-if="isImage">
				<img :src="filePreview" alt="preview" class="img-thumbnail" style="max-width: 150px;" />
			  </template>
			  <template v-else>
				<a :href="filePreview" target="_blank">View Uploaded File</a>
			  </template>
			</div>

			<div class="text-danger" v-if="fileError">{{ fileError }}</div>
		  </div>
		  
	
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Status <span class="text-danger">*</span></label
              >
			  <Field
                    name="status"
                    as="select"
                    class="form-control"
					v-model="form.status"
					:class="{ 'is-invalid': errors.status }"
                  >
				  <option value="">Select Status</option>
				  <option value="Approved">Approved</option>
				  <option value="Pending">Pending</option>
				  <option value="Declined">Declined</option>
				  <div class="invalid-feedback">{{ errors.status }}</div>
                  <div class="statusshow text-danger" id="status"></div>
			  </Field>
			</div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Leave Modal -->

  <!-- Edit Leave Modal -->
  <div id="edit_leave" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Leave</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
			ref="editleaveclose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onUpdate" :validation-schema="editschema" v-slot="{ errors }">
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Employee <span class="text-danger">*</span></label
              >
			  <Field
                    name="employee_id"
                    as="select"
                    class="form-control"
					v-model="editform.employee_id"
					:class="{ 'is-invalid': errors.employee_id }"
                  >
				  <option value="">Select Employee</option>
				  <option v-for="employee in employeelist" :key="employee.id" :value="employee.id">{{ employee.first_name }} {{employee.last_name}}</option>
				  <div class="invalid-feedback">{{ errors.employee_id }}</div>
                  <div class="employee_idshow text-danger" id="employee_id"></div>
			  </Field>
			</div>
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Leave Type <span class="text-danger">*</span></label
              >
			  <Field
                    name="leave_type_id"
                    as="select"
                    class="form-control"
					v-model="editform.leave_type_id"
					:class="{ 'is-invalid': errors.leave_type_id }"
					@change="onLeaveTypeChange2"
                  >
				  <option value="">Select Leave Type</option>
				  <!--<option v-for="leavetype in leavetypelist" :key="leavetype.id" :value="leavetype.id">{{ leavetype.type }}</option> -->
				  <option v-for="leavetype in newleavetypelist" :key="leavetype.id" :value="leavetype.id">{{ leavetype.name }}</option>
				  <div class="invalid-feedback">{{ errors.leave_type_id }}</div>
                  <div class="leave_type_idshow text-danger" id="leave_type_id"></div>
			  </Field>
			  <!--
              <vue-select
                :options="SelectType"
                id="medical-leave"
                placeholder="Select Leave Type"
              /> -->
            </div>
			<!--
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Leave Type <span class="text-danger">*</span></label
              >
			  
			  {{editform}}
              <vue-select
                :options="SelectLeave"
                id="casual"
                placeholder="Select Leave type"
              />
            </div>-->
            <div class="input-block mb-3">
			  <label class="col-form-label"
                >From <span class="text-danger">*</span></label
              >
              <div class="cal-icon">
                <datepicker
                  v-model="editobjfrom"
                  placeholder="2023-01-01"
                  class="form-control datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
                />
              </div>
            </div>
            <div class="input-block mb-3">
			  <label class="col-form-label">To <span class="text-danger">*</span></label>
              <div class="cal-icon">
                <datepicker
                  v-model="editobjto"
                  placeholder="2023-01-01"
                  class="form-control datetimepicker"
                  :editable="true"
                  :clearable="false"
                  :input-format="dateFormat"
                />
              </div>
            </div>
			
			
			<div class="row" v-if="form.leavedetails">
			  <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6" v-for="(item, index) in editform.leavedetails" :key="item">
				<div class="input-block mb-3">
					<label class="col-form-label">{{ formattedDate(item.leave_details_date) }} <span class="text-danger"></span></label>
					<div class="form-check">
						<input type="radio" value="FULLDAY"  v-model="editform.leavedetails[index]['leave_details_type']" /> Full Day
					</div>
					<div class="form-check">
					<input type="radio" value="HALFDAY"  v-model="editform.leavedetails[index]['leave_details_type']"  /> Half Day
					</div>
				</div>
			  </div>
			</div>  
			   	
			<!--
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Number of days <span class="text-danger">*</span></label
              >
              <input class="form-control" readonly type="text" value="2" />
            </div>
            <div class="input-block mb-3">
              <label class="col-form-label"
                >Remaining Leaves <span class="text-danger">*</span></label
              >
              <input class="form-control" readonly value="12" type="text" />
            </div> -->
            <!-- <div class="input-block mb-3">
              <label class="col-form-label"
                >Leave Reason <span class="text-danger">*</span></label
              >
              <textarea rows="4" class="form-control">Going to hospital</textarea>
            </div> -->
			
			<div class="input-block mb-3">
              <label class="col-form-label"
                >Leave Reason <span class="text-danger">*</span></label
              >
              <Field
                    name="reason"
                    as="textarea"
                    value=""
                    class="form-control"
					v-model="editform.reason"
					rows="4"
					:class="{ 'is-invalid': errors.reason }"
                  />
                  <div class="invalid-feedback">{{ errors.reason }}</div>
                  <div class="nameshow text-danger" id="reason"></div>
            </div>
			
			<div class="input-block mb-3" v-if="!editPreview && editform.attachment_url">
			  <label class="col-form-label">Current Attachment</label>
			  <!-- If it's an image -->
			  <div v-if="isImage2(editform.attachment_url)">
				<img :src="editform.attachment_url" 
					 class="img-thumbnail mt-2"
					 style="max-width: 200px; border-radius: 6px;">
			  </div>

			  <!-- If it's PDF -->
			  <div v-else>
				<a :href="editform.attachment_url" 
				   target="_blank" 
				   class="btn btn-sm btn-outline-primary mt-2">
				  View PDF
				</a>
			  </div>
			</div>
			
			<div class="input-block mb-3" v-if="editPreview">
			  <label class="col-form-label">New Attachment Preview</label>

			  <!-- If image -->
			  <div v-if="editPreviewType && editPreviewType.startsWith('image/')">
				<img :src="editPreview"
					 class="img-thumbnail mt-2"
					 style="max-width: 200px;">
			  </div>

			  <!-- If PDF -->
			  <div v-else>
				<a :href="editPreview"
				   target="_blank"
				   class="btn btn-sm btn-outline-primary mt-2">
				  View File
				</a>
			  </div>
			</div>

			

			<!-- Replace Attachment -->
			<div class="input-block mb-3">
			  <label class="col-form-label">Attachment (Optional)</label>
			  <input type="file" class="form-control" @change="handleFileUploadEdit" ref="editFileInput" />
			</div>


			<div class="input-block mb-3">
              <label class="col-form-label"
                >Status <span class="text-danger">*</span></label
              >
			  <Field
                    name="status"
                    as="select"
                    class="form-control"
					v-model="editform.status"
					:class="{ 'is-invalid': errors.status }"
                  >
				  <option value="">Select Status</option>
				  <option value="Approved">Approved</option>
				  <option value="Pending">Pending</option>
				  <option value="Declined">Declined</option>
				  <div class="invalid-feedback">{{ errors.status }}</div>
                  <div class="statusshow text-danger" id="status"></div>
			  </Field>
			</div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Save</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Leave Modal -->

  <!-- Approve Leave Modal -->
  <div class="modal custom-modal fade" id="approve_leave" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Update Leave</h3>
            <p>Are you sure want to update this leave?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-primary continue-btn" @click="updateLeave"
                  >Update</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-primary cancel-btn"
				  ref="updateleaveclose"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Approve Leave Modal -->

  <!-- Delete Leave Modal -->
  <div class="modal custom-modal fade" id="delete_approve" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Delete Leave</h3>
            <p>Are you sure want to delete this leave?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-primary continue-btn" @click="deleteLeave"
                  >Delete</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-primary cancel-btn" ref="deleteleaveclose"
                  >Cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Leave Modal -->
</template>

<script>
import { ref } from "vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());

import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import moment from 'moment';


export default {
  emits: ["createLeave","updateLeave","updateLeavestatus","deleteLeave","createLeaveDates"],
  components: {
    Form,
    Field,
  },
  props: {
    form: [Array, Object],
	leavetypelist: [Array, Object],
	newleavetypelist: [Array, Object],
	employeelist: [Array, Object],
	editform: [Array, Object],
	update_id: [Number,String],
	update_status: [Number,String],
	updateleavetype_id: [Number,String],
	delleave_id: [Number,String],
  },  
  data() {
    return {
	   editPreview: null,
	   editPreviewType: null,
	   items : [{txt: 'foo', val: 1, val2: 2},{txt: 'bar', val: 1, val2: 2},{txt: 'foo', val: 1, val2: 2}],
      checked:'',
      select2: null,
      SelectType: [
        "Select Leave Type",
        "Casual Leave 12 Days",
        "Medical Leave",
        "Loss of Pay",
      ],
	  createdfrom: currentDate,
	  createdto: currentDateOne,
      SelectLeave: ["Select Leave Type", "Casual Leave 12 Days"],
      startdate: currentDate,
      dateFormat: 'MM-dd-yyyy',
      startdateone: currentDateOne,
	  selected: 'A',
	  options: [
		  { item: 'A', name: 'Option A' },
		  { item: 'B', name: 'Option B' },
		  { item: 'D', name: 'Option C', notEnabled: true },
		  { item: { d: 1 }, name: 'Option D' }
	  ],
	  products: [],
	  test: '',
	  editobjfrom: '',
	  editobjto: '',
	  selectedLeave: null,
	  selectededitLeave: null,
	  filePreview: null,
	  fileError: "",
	  isImage: false,
    };
  },
  methods: {
	isImage2(url) {
		return /\.(jpg|jpeg|png)$/i.test(url);
    },
    handleFileUploadEdit(event) {
		var file = event.target.files[0];
		
		if (!file) return;

	   this.editform.attachment = file;          // assign new file to upload
	   this.editPreview = URL.createObjectURL(file); // set new preview
	   
	   this.editPreviewType = file.type; // <-- Store MIME type
  
	},
	onLeaveTypeChange2(){
	
		this.selectededitLeave = this.newleavetypelist.find((lt) => lt.id === this.editform.leave_type_id) || null;
		
		if (this.selectededitLeave) {
			console.log("Selected Leave:", this.selectededitLeave.name);
			console.log("Entitlement:", this.selectededitLeave.entitlement_days);
			
			var entitlementDays = parseFloat(this.selectededitLeave.entitlement_days) || 0;
			
			var today = new Date();
			this.editobjfrom = today;
			
			if (entitlementDays > 0) {
				var toDate = new Date(today);
				toDate.setDate(today.getDate() + entitlementDays - 1);
				this.editobjto = toDate;
			} else {
				// If entitlementDays = 0, same as from_date
				this.editobjto = today;
			}
		
		} else {
			console.log("Leave type cleared or not found.");
			
			var today = new Date();
			this.editobjfrom = today;
			this.editobjto = today;	
		}
	},
	onFileChange(e) {
		const file = e.target.files[0];
		this.fileError = "";
		this.filePreview = null;
		this.isImage = false;

		if (!file) return;

		const validTypes = ["image/jpeg", "image/png", "application/pdf"];
		if (!validTypes.includes(file.type)) {
		  this.fileError = "Only JPG, PNG, or PDF files are allowed.";
		  return;
		}

		if (file.size > 2 * 1024 * 1024) {
		  this.fileError = "File size must be under 2MB.";
		  return;
		}

		this.form.attachment = file;

		// preview setup
		if (file.type.startsWith("image/")) {
		  this.isImage = true;
		  this.filePreview = URL.createObjectURL(file);
		} else {
		  this.filePreview = URL.createObjectURL(file);
		}
	},
	onLeaveTypeChange(){
		console.log('test..');	
		console.log(this.form.leave_type_id);
		
		this.selectedLeave =  this.newleavetypelist.find((lt) => lt.id === this.form.leave_type_id) || null;
		
		if (this.selectedLeave) {
			console.log("Selected Leave:", this.selectedLeave.name);
			console.log("Entitlement:", this.selectedLeave.entitlement_days);
			
			var entitlementDays = parseFloat(this.selectedLeave.entitlement_days) || 0;
			
			var today = new Date();
			this.createdfrom = today;
			
			if (entitlementDays > 0) {
				var toDate = new Date(today);
				toDate.setDate(today.getDate() + entitlementDays - 1);
				this.createdto = toDate;
			} else {
				// If entitlementDays = 0, same as from_date
				this.createdto = today;
			}
		
		} else {
			console.log("Leave type cleared or not found.");
			
			var today = new Date();
			this.createdfrom = today;
			this.createdto = today;
			
			
		}
	},
	formattedDate(formatdate){
		return moment(formatdate).format('MM-DD-YYYY');
	},
    onDateChange(){
	
		this.$emit("create-leavedates",this.createdfrom,this.createdto);
	},
	onDateEditChange(){
	
		this.$emit("edit-leavedates",this.editobjfrom,this.editobjto);
	},
	onSubmit(values) {
	   
	  
		values.from = moment(this.createdfrom).format('YYYY-MM-DD');
		values.to = moment(this.createdto).format('YYYY-MM-DD');
		values.leave_data = this.form.leavedetails;
		
		if (this.form.attachment) {
			values.attachment = this.form.attachment;
		}
		
		this.$emit("create-leave",values);
	},
	closeDialog(){
		this.$refs.addleaveclose.click();
		this.$refs.editleaveclose.click();
		this.$refs.updateleaveclose.click();
		this.$refs.deleteleaveclose.click();
		
		
		this.filePreview = null;
		this.fileError = null;
		
		if (this.$refs.addFileInput) {
			this.$refs.addFileInput.value = null;
		}
		
		this.editPreview = null;
		this.editPreviewType = null;
	
		if (this.$refs.editFileInput) {
			this.$refs.editFileInput.value = null;
		}
	},
	onUpdate(formval){
		
		
		this.editform.from = moment(this.editobjfrom).format('YYYY-MM-DD');
		this.editform.to = moment(this.editobjto).format('YYYY-MM-DD');
		this.editform.leave_data = this.editform.leavedetails;
		
		
		this.$emit("update-leave",this.editform);
		
	},
	updateLeave(){
		
		this.$emit("update-leavestatus",this.update_id,this.updateleavetype_id,this.update_status);
	},
	deleteLeave(){
		this.$emit("delete-leave",this.delleave_id);
	},
	seteditdates(editobjfrom,editobjto){
		
		this.editobjto = editobjto;
		this.editobjfrom = editobjfrom;
	  
	}
  },
  setup() {
    const schema = Yup.object().shape({
	  employee_id: Yup.string().required("Employee is required"),
	  leave_type_id: Yup.string().required("Leave Type is required"),
      status: Yup.string().required("Status is required"),
	  reason: Yup.string().required("Reason is required"),
	});
	
	const editschema = Yup.object().shape({
	  employee_id: Yup.string().required("Employee is required"),
	  leave_type_id: Yup.string().required("Leave Type is required"),
      status: Yup.string().required("Status is required"),
	  reason: Yup.string().required("Reason is required"),
	});
	
	return {
      schema,
	  editschema
	};
  },
  watch: {
    createdfrom(val){
		
	
		this.onDateChange();
	},
	createdto(val){
		
		
		this.onDateChange();
	},
	editobjto(val){
		
	
		this.onDateEditChange();
	},
	editobjfrom(val){
		
		
		this.onDateEditChange();
	}
  }
};
</script>
